import { RouteOverrideFunction } from '../types/RouteOverrideFunction';

export const defaultOverrideFunction: RouteOverrideFunction = () => {};
